// ค่าที่ Coreplan AI กรอกฟอร์มให้ — เก็บใน sessionStorage ชั่วคราวระหว่างนำทางไปหน้าฟอร์ม แล้วฟอร์มอ่านครั้งเดียวตอน mount
// (ไม่ส่งแทนผู้ใช้: ฟอร์มแค่เติมค่าเริ่มต้น ผู้ใช้ตรวจแล้วกดส่งเอง)
const KEY = 'ai_form_prefill';
const MAX_AGE_MS = 2 * 60 * 1000;

export function stashAiPrefill(form, values) {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ form, values, ts: Date.now() }));
  } catch (e) { /* sessionStorage ใช้ไม่ได้ = ไม่เติมค่า */ }
}

// อ่านโดยไม่ลบ (React StrictMode เรียก initializer 2 รอบ) — ฟอร์มเรียก clearAiPrefill() ใน useEffect หลัง mount
export function takeAiPrefill(form) {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const data = JSON.parse(raw);
    if (data.form !== form || Date.now() - data.ts > MAX_AGE_MS) return null;
    return data.values || null;
  } catch (e) {
    return null;
  }
}

export function clearAiPrefill() {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) { /* ไม่มีอะไรต้องทำ */ }
}
